module.exports = __webpack_public_path__ + "img/magento-custom-development.7e182d8f.webp";